//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AdAuthenticateClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param jwt (optional) 
     * @return Success
     */
    getLocalToken(jwt: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/scheduler/AdAuthenticate/GetLocalToken?";
        if (jwt !== undefined && jwt !== null)
            url_ += "jwt=" + encodeURIComponent("" + jwt) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocalToken(_response);
        });
    }

    protected processGetLocalToken(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class CustomerAgreementClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param productKeys (optional) 
     * @return Success
     */
    getAll(productKeys: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetCustomerAgreementListResponse> {
        let url_ = this.baseUrl + "/api/CustomerAgreement/GetAll?";
        if (productKeys !== undefined && productKeys !== null)
            url_ += "ProductKeys=" + encodeURIComponent("" + productKeys) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<GetCustomerAgreementListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCustomerAgreementListResponse.fromJS(resultData200);
            return Promise.resolve<GetCustomerAgreementListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCustomerAgreementListResponse>(null as any);
    }
}

export class DebugCommandClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    executeDebugText(body: ExecuteDebugTextCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<ExecuteDebugTextResponse> {
        let url_ = this.baseUrl + "/scheduler/DebugCommand/ExecuteDebugText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExecuteDebugText(_response);
        });
    }

    protected processExecuteDebugText(response: AxiosResponse): Promise<ExecuteDebugTextResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExecuteDebugTextResponse.fromJS(resultData200);
            return Promise.resolve<ExecuteDebugTextResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExecuteDebugTextResponse>(null as any);
    }
}

export class FavoriteListClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<GetByIdFavoriteListResponse> {
        let url_ = this.baseUrl + "/api/FavoriteList/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<GetByIdFavoriteListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetByIdFavoriteListResponse.fromJS(resultData200);
            return Promise.resolve<GetByIdFavoriteListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetByIdFavoriteListResponse>(null as any);
    }

    /**
     * Return list without items but with the details
     * @param request (optional) 
     * @return Success
     */
    getAllDetails(request: GetAllFavoriteListDetailsRequest | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetAllFavoriteListDetailsResponse> {
        let url_ = this.baseUrl + "/api/FavoriteList/GetAllDetails?";
        if (request !== undefined && request !== null)
            url_ += "request=" + encodeURIComponent("" + request) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllDetails(_response);
        });
    }

    protected processGetAllDetails(response: AxiosResponse): Promise<GetAllFavoriteListDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllFavoriteListDetailsResponse.fromJS(resultData200);
            return Promise.resolve<GetAllFavoriteListDetailsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllFavoriteListDetailsResponse>(null as any);
    }

    /**
     * @param productKeys (optional) 
     * @return Success
     */
    getAll(productKeys: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetAllFavoriteListResponse> {
        let url_ = this.baseUrl + "/api/FavoriteList/GetAll?";
        if (productKeys !== undefined && productKeys !== null)
            url_ += "ProductKeys=" + encodeURIComponent("" + productKeys) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<GetAllFavoriteListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllFavoriteListResponse.fromJS(resultData200);
            return Promise.resolve<GetAllFavoriteListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllFavoriteListResponse>(null as any);
    }

    /**
     * @param productKeys (optional) 
     * @return Success
     */
    getListByProductKeys(productKeys: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetListByProductKeysResponse> {
        let url_ = this.baseUrl + "/api/FavoriteList/GetListByProductKeys?";
        if (productKeys !== undefined && productKeys !== null)
            productKeys && productKeys.forEach(item => { url_ += "ProductKeys=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListByProductKeys(_response);
        });
    }

    protected processGetListByProductKeys(response: AxiosResponse): Promise<GetListByProductKeysResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetListByProductKeysResponse.fromJS(resultData200);
            return Promise.resolve<GetListByProductKeysResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetListByProductKeysResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateFavoriteListCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<CreateFavoriteListResponse> {
        let url_ = this.baseUrl + "/api/FavoriteList/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreateFavoriteListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateFavoriteListResponse.fromJS(resultData200);
            return Promise.resolve<CreateFavoriteListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateFavoriteListResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateFavoriteListCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/FavoriteList/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    delete(body: DeleteFavoriteListCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/FavoriteList/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    invalidateAll(body: CacheInvalidateFavoriteListCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/FavoriteList/InvalidateAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvalidateAll(_response);
        });
    }

    protected processInvalidateAll(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addItem(body: AddItemToFavoriteListCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<AddItemToFavoriteListResponse> {
        let url_ = this.baseUrl + "/api/FavoriteList/AddItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddItem(_response);
        });
    }

    protected processAddItem(response: AxiosResponse): Promise<AddItemToFavoriteListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddItemToFavoriteListResponse.fromJS(resultData200);
            return Promise.resolve<AddItemToFavoriteListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddItemToFavoriteListResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeItem(body: RemoveItemFromFavoriteListCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/FavoriteList/RemoveItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveItem(_response);
        });
    }

    protected processRemoveItem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeAllItems(body: RemoveItemFromAllFavoriteListsCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/FavoriteList/RemoveAllItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveAllItems(_response);
        });
    }

    protected processRemoveAllItems(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class FormZipClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    post(body: PostZip | null | undefined , cancelToken?: CancelToken | undefined): Promise<HttpResponseMessage> {
        let url_ = this.baseUrl + "/api/FormZip/post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<HttpResponseMessage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HttpResponseMessage.fromJS(resultData200);
            return Promise.resolve<HttpResponseMessage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HttpResponseMessage>(null as any);
    }
}

export class JobsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param args (optional) 
     * @return Success
     */
    getJobs(args: GetJobsQuery | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetJobsResponse> {
        let url_ = this.baseUrl + "/scheduler/Jobs/GetJobs?";
        if (args !== undefined && args !== null)
            url_ += "args=" + encodeURIComponent("" + args) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobs(_response);
        });
    }

    protected processGetJobs(response: AxiosResponse): Promise<GetJobsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetJobsResponse.fromJS(resultData200);
            return Promise.resolve<GetJobsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetJobsResponse>(null as any);
    }

    /**
     * @param importance (optional) 
     * @param state (optional) 
     * @return Success
     */
    getRunningJobs(importance: Importance | null | undefined, state: RunningJobState | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetRunningJobsResponse> {
        let url_ = this.baseUrl + "/scheduler/Jobs/GetRunningJobs?";
        if (importance !== undefined && importance !== null)
            url_ += "Importance=" + encodeURIComponent("" + importance) + "&";
        if (state !== undefined && state !== null)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRunningJobs(_response);
        });
    }

    protected processGetRunningJobs(response: AxiosResponse): Promise<GetRunningJobsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRunningJobsResponse.fromJS(resultData200);
            return Promise.resolve<GetRunningJobsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRunningJobsResponse>(null as any);
    }

    /**
     * @param args (optional) 
     * @return Success
     */
    getJobTypes(args: GetJobTypesQuery | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetJobTypesResponse> {
        let url_ = this.baseUrl + "/scheduler/Jobs/GetJobTypes?";
        if (args !== undefined && args !== null)
            url_ += "args=" + encodeURIComponent("" + args) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobTypes(_response);
        });
    }

    protected processGetJobTypes(response: AxiosResponse): Promise<GetJobTypesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetJobTypesResponse.fromJS(resultData200);
            return Promise.resolve<GetJobTypesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetJobTypesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    startJob(body: StartJobCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/scheduler/Jobs/StartJob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartJob(_response);
        });
    }

    protected processStartJob(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param jobName (optional) 
     * @return Success
     */
    startJobByNameWithWaitPost(jobName: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/scheduler/Jobs/StartJobByNameWithWait?";
        if (jobName !== undefined && jobName !== null)
            url_ += "JobName=" + encodeURIComponent("" + jobName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartJobByNameWithWaitPost(_response);
        });
    }

    protected processStartJobByNameWithWaitPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param jobName (optional) 
     * @return Success
     */
    startJobByNameWithWaitGet(jobName: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/scheduler/Jobs/StartJobByNameWithWait?";
        if (jobName !== undefined && jobName !== null)
            url_ += "JobName=" + encodeURIComponent("" + jobName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartJobByNameWithWaitGet(_response);
        });
    }

    protected processStartJobByNameWithWaitGet(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OrderingListClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * Get Master collection for user - the master collection is the default orderinglist for the user
     * @param productKeys (optional) 
     * @param showFromMasterList (optional) 
     * @return Success
     */
    getMasterList(productKeys: string | null | undefined, showFromMasterList: boolean | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetMasterOrderingListResponse> {
        let url_ = this.baseUrl + "/api/OrderingList/GetMasterList?";
        if (productKeys !== undefined && productKeys !== null)
            url_ += "ProductKeys=" + encodeURIComponent("" + productKeys) + "&";
        if (showFromMasterList !== undefined && showFromMasterList !== null)
            url_ += "ShowFromMasterList=" + encodeURIComponent("" + showFromMasterList) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMasterList(_response);
        });
    }

    protected processGetMasterList(response: AxiosResponse): Promise<GetMasterOrderingListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMasterOrderingListResponse.fromJS(resultData200);
            return Promise.resolve<GetMasterOrderingListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMasterOrderingListResponse>(null as any);
    }

    /**
     * Get list by id
     * @param id (optional) 
     * @param productKeys (optional) 
     * @param showFromMasterList (optional) 
     * @return Success
     */
    getById(id: string | undefined, productKeys: string | null | undefined, showFromMasterList: boolean | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetByIdOrderingListResponse> {
        let url_ = this.baseUrl + "/api/OrderingList/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (productKeys !== undefined && productKeys !== null)
            url_ += "ProductKeys=" + encodeURIComponent("" + productKeys) + "&";
        if (showFromMasterList !== undefined && showFromMasterList !== null)
            url_ += "ShowFromMasterList=" + encodeURIComponent("" + showFromMasterList) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<GetByIdOrderingListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetByIdOrderingListResponse.fromJS(resultData200);
            return Promise.resolve<GetByIdOrderingListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetByIdOrderingListResponse>(null as any);
    }

    /**
     * Get list by id
     * @param id (optional) 
     * @param userIdentity (optional) 
     * @return Success
     */
    getRealizedBudget(id: string | undefined, userIdentity: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetRealizedBudgetResponse> {
        let url_ = this.baseUrl + "/api/OrderingList/GetRealizedBudget?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (userIdentity !== undefined && userIdentity !== null)
            url_ += "UserIdentity=" + encodeURIComponent("" + userIdentity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRealizedBudget(_response);
        });
    }

    protected processGetRealizedBudget(response: AxiosResponse): Promise<GetRealizedBudgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRealizedBudgetResponse.fromJS(resultData200);
            return Promise.resolve<GetRealizedBudgetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRealizedBudgetResponse>(null as any);
    }

    /**
     * Get a list of details about every allowed lists
     * @param getEmployeeLists (optional) 
     * @param userIdentity (optional) 
     * @return Success
     */
    getListDetails(getEmployeeLists: boolean | undefined, userIdentity: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetAllOrderingListDetailsResponse> {
        let url_ = this.baseUrl + "/api/OrderingList/GetListDetails?";
        if (getEmployeeLists === null)
            throw new Error("The parameter 'getEmployeeLists' cannot be null.");
        else if (getEmployeeLists !== undefined)
            url_ += "GetEmployeeLists=" + encodeURIComponent("" + getEmployeeLists) + "&";
        if (userIdentity !== undefined && userIdentity !== null)
            url_ += "UserIdentity=" + encodeURIComponent("" + userIdentity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListDetails(_response);
        });
    }

    protected processGetListDetails(response: AxiosResponse): Promise<GetAllOrderingListDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllOrderingListDetailsResponse.fromJS(resultData200);
            return Promise.resolve<GetAllOrderingListDetailsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllOrderingListDetailsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOrderingListCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<CreateOrderingListResponse> {
        let url_ = this.baseUrl + "/api/OrderingList/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreateOrderingListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateOrderingListResponse.fromJS(resultData200);
            return Promise.resolve<CreateOrderingListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateOrderingListResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateOrderingListCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/OrderingList/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    delete(body: DeleteOrderingListCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/OrderingList/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Only for testing..
     * @param body (optional) 
     * @return Success
     */
    invalidateCache(body: CacheInvalidateOrderingListCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/OrderingList/InvalidateCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvalidateCache(_response);
        });
    }

    protected processInvalidateCache(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addItem(body: AddItemToOrderingListCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/OrderingList/AddItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddItem(_response);
        });
    }

    protected processAddItem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeItem(body: RemoveItemFromOrderingListCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<AddItemToOrderingListResponse> {
        let url_ = this.baseUrl + "/api/OrderingList/RemoveItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveItem(_response);
        });
    }

    protected processRemoveItem(response: AxiosResponse): Promise<AddItemToOrderingListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddItemToOrderingListResponse.fromJS(resultData200);
            return Promise.resolve<AddItemToOrderingListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddItemToOrderingListResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateIsActive(body: UpdateIsActiveOnOrderingListItemCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/OrderingList/UpdateIsActive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateIsActive(_response);
        });
    }

    protected processUpdateIsActive(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateIsDeleted(body: UpdateIsDeletedOnOrderingListItemCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/OrderingList/UpdateIsDeleted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateIsDeleted(_response);
        });
    }

    protected processUpdateIsDeleted(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateIsAvailable(body: UpdateIsAvailableOnOrderingListItemCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/OrderingList/UpdateIsAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateIsAvailable(_response);
        });
    }

    protected processUpdateIsAvailable(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OrderingListRequestProductClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param withUserInfo (optional) 
     * @return Success
     */
    getAll(withUserInfo: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<GetAllOrderingListPendingResponse> {
        let url_ = this.baseUrl + "/api/OrderingListRequestProduct/GetAll?";
        if (withUserInfo === null)
            throw new Error("The parameter 'withUserInfo' cannot be null.");
        else if (withUserInfo !== undefined)
            url_ += "WithUserInfo=" + encodeURIComponent("" + withUserInfo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<GetAllOrderingListPendingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllOrderingListPendingResponse.fromJS(resultData200);
            return Promise.resolve<GetAllOrderingListPendingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllOrderingListPendingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approve(body: ApproveOrderingListRequestProductCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/OrderingListRequestProduct/Approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApprove(_response);
        });
    }

    protected processApprove(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancel(body: CancelOrderingListRequestProductCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/OrderingListRequestProduct/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancel(_response);
        });
    }

    protected processCancel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    add(body: AddOrderingListRequestProductCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/OrderingListRequestProduct/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    getAllScheduled(request: GetAllEmailPendingRequest | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetAllEmailPendingResponse> {
        let url_ = this.baseUrl + "/api/OrderingListRequestProduct/GetAllScheduled?";
        if (request !== undefined && request !== null)
            url_ += "request=" + encodeURIComponent("" + request) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllScheduled(_response);
        });
    }

    protected processGetAllScheduled(response: AxiosResponse): Promise<GetAllEmailPendingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllEmailPendingResponse.fromJS(resultData200);
            return Promise.resolve<GetAllEmailPendingResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllEmailPendingResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markScheduledAsSend(body: MarkOrderingPendingRequestAsSendRequest | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/OrderingListRequestProduct/MarkScheduledAsSend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkScheduledAsSend(_response);
        });
    }

    protected processMarkScheduledAsSend(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OrderingListUserPermissionClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param request (optional) 
     * @return Success
     */
    getAll(request: GetAllOrderingListUserPermissionRequest | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetAllOrderingListUserPermissionResponse> {
        let url_ = this.baseUrl + "/api/OrderingListUserPermission/GetAll?";
        if (request !== undefined && request !== null)
            url_ += "request=" + encodeURIComponent("" + request) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<GetAllOrderingListUserPermissionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllOrderingListUserPermissionResponse.fromJS(resultData200);
            return Promise.resolve<GetAllOrderingListUserPermissionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllOrderingListUserPermissionResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserPermission(body: UpdateUserPermissionCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/OrderingListUserPermission/UpdateUserPermission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserPermission(_response);
        });
    }

    protected processUpdateUserPermission(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUserPermission(body: CreateUserPermissionCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/OrderingListUserPermission/CreateUserPermission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUserPermission(_response);
        });
    }

    protected processCreateUserPermission(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeUserPermission(body: RemoveUserPermissionCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/OrderingListUserPermission/RemoveUserPermission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveUserPermission(_response);
        });
    }

    protected processRemoveUserPermission(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ReportingEventClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param jobId (optional) 
     * @param onlyLatest (optional) 
     * @return Success
     */
    getReportingEvents(jobId: string | undefined, onlyLatest: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<GetReportingEventsResponse> {
        let url_ = this.baseUrl + "/scheduler/ReportingEvent/GetReportingEvents?";
        if (jobId === null)
            throw new Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "JobId=" + encodeURIComponent("" + jobId) + "&";
        if (onlyLatest === null)
            throw new Error("The parameter 'onlyLatest' cannot be null.");
        else if (onlyLatest !== undefined)
            url_ += "OnlyLatest=" + encodeURIComponent("" + onlyLatest) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReportingEvents(_response);
        });
    }

    protected processGetReportingEvents(response: AxiosResponse): Promise<GetReportingEventsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetReportingEventsResponse.fromJS(resultData200);
            return Promise.resolve<GetReportingEventsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetReportingEventsResponse>(null as any);
    }
}

export class SchedulingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param args (optional) 
     * @return Success
     */
    getJobSchedules(args: GetJobSchedulesQuery | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetJobSchedulesResponse> {
        let url_ = this.baseUrl + "/scheduler/Scheduling/GetJobSchedules?";
        if (args !== undefined && args !== null)
            url_ += "args=" + encodeURIComponent("" + args) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobSchedules(_response);
        });
    }

    protected processGetJobSchedules(response: AxiosResponse): Promise<GetJobSchedulesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetJobSchedulesResponse.fromJS(resultData200);
            return Promise.resolve<GetJobSchedulesResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetJobSchedulesResponse>(null as any);
    }

    /**
     * @param jobId (optional) 
     * @return Success
     */
    getJobScheduleByJobId(jobId: string | undefined , cancelToken?: CancelToken | undefined): Promise<GetJobScheduleByJobIdResponse> {
        let url_ = this.baseUrl + "/scheduler/Scheduling/GetJobScheduleByJobId?";
        if (jobId === null)
            throw new Error("The parameter 'jobId' cannot be null.");
        else if (jobId !== undefined)
            url_ += "JobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobScheduleByJobId(_response);
        });
    }

    protected processGetJobScheduleByJobId(response: AxiosResponse): Promise<GetJobScheduleByJobIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetJobScheduleByJobIdResponse.fromJS(resultData200);
            return Promise.resolve<GetJobScheduleByJobIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetJobScheduleByJobIdResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteJobScheduleByJobId(body: DeleteJobScheduleByJobIdCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/scheduler/Scheduling/DeleteJobScheduleByJobId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteJobScheduleByJobId(_response);
        });
    }

    protected processDeleteJobScheduleByJobId(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addOrUpdateJobSchedule(body: AddOrUpdateJobScheduleCommand | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/scheduler/Scheduling/AddOrUpdateJobSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrUpdateJobSchedule(_response);
        });
    }

    protected processAddOrUpdateJobSchedule(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TestClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    test(  cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Test/Test";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTest(_response);
        });
    }

    protected processTest(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class UserHierarchyClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param request (optional) 
     * @return Success
     */
    getHierarchy(request: GetUserHierarchyDetailsRequest | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetUserHierarchyDetailsResponse> {
        let url_ = this.baseUrl + "/api/UserHierarchy/GetHierarchy?";
        if (request !== undefined && request !== null)
            url_ += "request=" + encodeURIComponent("" + request) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHierarchy(_response);
        });
    }

    protected processGetHierarchy(response: AxiosResponse): Promise<GetUserHierarchyDetailsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserHierarchyDetailsResponse.fromJS(resultData200);
            return Promise.resolve<GetUserHierarchyDetailsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserHierarchyDetailsResponse>(null as any);
    }

    /**
     * @param empty (optional) 
     * @return Success
     */
    clearCache(empty: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserHierarchy/ClearCache?";
        if (empty !== undefined && empty !== null)
            url_ += "empty=" + encodeURIComponent("" + empty) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearCache(_response);
        });
    }

    protected processClearCache(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    getCreateNewChildUserHierarchyList(request: GetCreateNewChildUserHierarchyListRequest | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetCreateNewChildUserHierarchyListResponse> {
        let url_ = this.baseUrl + "/api/UserHierarchy/GetCreateNewChildUserHierarchyList?";
        if (request !== undefined && request !== null)
            url_ += "request=" + encodeURIComponent("" + request) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCreateNewChildUserHierarchyList(_response);
        });
    }

    protected processGetCreateNewChildUserHierarchyList(response: AxiosResponse): Promise<GetCreateNewChildUserHierarchyListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCreateNewChildUserHierarchyListResponse.fromJS(resultData200);
            return Promise.resolve<GetCreateNewChildUserHierarchyListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCreateNewChildUserHierarchyListResponse>(null as any);
    }

    /**
     * @param request (optional) 
     * @return Success
     */
    getUserHierarchyListWithoutOrderingList(request: GetUserHierarchyListWithoutOrderingListRequest | null | undefined , cancelToken?: CancelToken | undefined): Promise<GetUserHierarchyListWithoutOrderingListResponse> {
        let url_ = this.baseUrl + "/api/UserHierarchy/GetUserHierarchyListWithoutOrderingList?";
        if (request !== undefined && request !== null)
            url_ += "request=" + encodeURIComponent("" + request) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserHierarchyListWithoutOrderingList(_response);
        });
    }

    protected processGetUserHierarchyListWithoutOrderingList(response: AxiosResponse): Promise<GetUserHierarchyListWithoutOrderingListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserHierarchyListWithoutOrderingListResponse.fromJS(resultData200);
            return Promise.resolve<GetUserHierarchyListWithoutOrderingListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserHierarchyListWithoutOrderingListResponse>(null as any);
    }
}

export class GetCustomerAgreementListResponse implements IGetCustomerAgreementListResponse {
    productKeys?: string[] | undefined;

    constructor(data?: IGetCustomerAgreementListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productKeys"])) {
                this.productKeys = [] as any;
                for (let item of _data["productKeys"])
                    this.productKeys!.push(item);
            }
        }
    }

    static fromJS(data: any): GetCustomerAgreementListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerAgreementListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productKeys)) {
            data["productKeys"] = [];
            for (let item of this.productKeys)
                data["productKeys"].push(item);
        }
        return data;
    }
}

export interface IGetCustomerAgreementListResponse {
    productKeys?: string[] | undefined;
}

export class ExecuteDebugTextCommand implements IExecuteDebugTextCommand {
    jobId?: string;
    command?: string | undefined;

    constructor(data?: IExecuteDebugTextCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.command = _data["command"];
        }
    }

    static fromJS(data: any): ExecuteDebugTextCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteDebugTextCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["command"] = this.command;
        return data;
    }
}

export interface IExecuteDebugTextCommand {
    jobId?: string;
    command?: string | undefined;
}

export class ExecuteDebugTextResponse implements IExecuteDebugTextResponse {
    text?: string | undefined;

    constructor(data?: IExecuteDebugTextResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): ExecuteDebugTextResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteDebugTextResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        return data;
    }
}

export interface IExecuteDebugTextResponse {
    text?: string | undefined;
}

export class FavoriteListItem implements IFavoriteListItem {
    sortOrder?: number;
    note?: string | undefined;
    productKey?: string | undefined;
    favoriteListId?: number;

    constructor(data?: IFavoriteListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortOrder = _data["sortOrder"];
            this.note = _data["note"];
            this.productKey = _data["productKey"];
            this.favoriteListId = _data["favoriteListId"];
        }
    }

    static fromJS(data: any): FavoriteListItem {
        data = typeof data === 'object' ? data : {};
        let result = new FavoriteListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortOrder"] = this.sortOrder;
        data["note"] = this.note;
        data["productKey"] = this.productKey;
        data["favoriteListId"] = this.favoriteListId;
        return data;
    }
}

export interface IFavoriteListItem {
    sortOrder?: number;
    note?: string | undefined;
    productKey?: string | undefined;
    favoriteListId?: number;
}

export class FavoriteList implements IFavoriteList {
    readonly userIsolationKey?: string | undefined;
    name?: string | undefined;
    sortOrder?: number;
    isFromExternSource?: boolean;
    items?: FavoriteListItem[] | undefined;
    id?: number;

    constructor(data?: IFavoriteList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).userIsolationKey = _data["userIsolationKey"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            this.isFromExternSource = _data["isFromExternSource"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FavoriteListItem.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): FavoriteList {
        data = typeof data === 'object' ? data : {};
        let result = new FavoriteList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userIsolationKey"] = this.userIsolationKey;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        data["isFromExternSource"] = this.isFromExternSource;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IFavoriteList {
    userIsolationKey?: string | undefined;
    name?: string | undefined;
    sortOrder?: number;
    isFromExternSource?: boolean;
    items?: FavoriteListItem[] | undefined;
    id?: number;
}

export class GetByIdFavoriteListResponse implements IGetByIdFavoriteListResponse {
    favoriteList?: FavoriteList | undefined;

    constructor(data?: IGetByIdFavoriteListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.favoriteList = _data["favoriteList"] ? FavoriteList.fromJS(_data["favoriteList"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetByIdFavoriteListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetByIdFavoriteListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["favoriteList"] = this.favoriteList ? this.favoriteList.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetByIdFavoriteListResponse {
    favoriteList?: FavoriteList | undefined;
}

export class GetAllFavoriteListDetailsRequest implements IGetAllFavoriteListDetailsRequest {

    constructor(data?: IGetAllFavoriteListDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetAllFavoriteListDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllFavoriteListDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetAllFavoriteListDetailsRequest {
}

export class FavoriteListItemViewModel implements IFavoriteListItemViewModel {
    productKey?: string | undefined;
    sortOrder?: number;
    note?: string | undefined;

    constructor(data?: IFavoriteListItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productKey = _data["productKey"];
            this.sortOrder = _data["sortOrder"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): FavoriteListItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FavoriteListItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productKey"] = this.productKey;
        data["sortOrder"] = this.sortOrder;
        data["note"] = this.note;
        return data;
    }
}

export interface IFavoriteListItemViewModel {
    productKey?: string | undefined;
    sortOrder?: number;
    note?: string | undefined;
}

export class FavoriteListViewModel implements IFavoriteListViewModel {
    id?: number;
    readonly userIsolationKey?: string | undefined;
    name?: string | undefined;
    sortOrder?: number;
    itemsCount?: number;
    isFromExternSource?: boolean;
    items?: FavoriteListItemViewModel[] | undefined;

    constructor(data?: IFavoriteListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            (<any>this).userIsolationKey = _data["userIsolationKey"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            this.itemsCount = _data["itemsCount"];
            this.isFromExternSource = _data["isFromExternSource"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FavoriteListItemViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FavoriteListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FavoriteListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userIsolationKey"] = this.userIsolationKey;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        data["itemsCount"] = this.itemsCount;
        data["isFromExternSource"] = this.isFromExternSource;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFavoriteListViewModel {
    id?: number;
    userIsolationKey?: string | undefined;
    name?: string | undefined;
    sortOrder?: number;
    itemsCount?: number;
    isFromExternSource?: boolean;
    items?: FavoriteListItemViewModel[] | undefined;
}

export class GetAllFavoriteListDetailsResponse implements IGetAllFavoriteListDetailsResponse {
    favoriteLists?: FavoriteListViewModel[] | undefined;

    constructor(data?: IGetAllFavoriteListDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["favoriteLists"])) {
                this.favoriteLists = [] as any;
                for (let item of _data["favoriteLists"])
                    this.favoriteLists!.push(FavoriteListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllFavoriteListDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllFavoriteListDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.favoriteLists)) {
            data["favoriteLists"] = [];
            for (let item of this.favoriteLists)
                data["favoriteLists"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllFavoriteListDetailsResponse {
    favoriteLists?: FavoriteListViewModel[] | undefined;
}

export class GetAllFavoriteListResponse implements IGetAllFavoriteListResponse {
    favoriteLists?: FavoriteListViewModel[] | undefined;

    constructor(data?: IGetAllFavoriteListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["favoriteLists"])) {
                this.favoriteLists = [] as any;
                for (let item of _data["favoriteLists"])
                    this.favoriteLists!.push(FavoriteListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllFavoriteListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllFavoriteListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.favoriteLists)) {
            data["favoriteLists"] = [];
            for (let item of this.favoriteLists)
                data["favoriteLists"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllFavoriteListResponse {
    favoriteLists?: FavoriteListViewModel[] | undefined;
}

export class GetListByProductKeysResponse implements IGetListByProductKeysResponse {
    readonly productWithFavoriteLists?: FavoriteList[] | undefined;

    constructor(data?: IGetListByProductKeysResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productWithFavoriteLists"])) {
                (<any>this).productWithFavoriteLists = [] as any;
                for (let item of _data["productWithFavoriteLists"])
                    (<any>this).productWithFavoriteLists!.push(FavoriteList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetListByProductKeysResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetListByProductKeysResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productWithFavoriteLists)) {
            data["productWithFavoriteLists"] = [];
            for (let item of this.productWithFavoriteLists)
                data["productWithFavoriteLists"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetListByProductKeysResponse {
    productWithFavoriteLists?: FavoriteList[] | undefined;
}

export class CreateFavoriteListCommand implements ICreateFavoriteListCommand {
    name?: string | undefined;
    productKey?: string | undefined;

    constructor(data?: ICreateFavoriteListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.productKey = _data["productKey"];
        }
    }

    static fromJS(data: any): CreateFavoriteListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFavoriteListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["productKey"] = this.productKey;
        return data;
    }
}

export interface ICreateFavoriteListCommand {
    name?: string | undefined;
    productKey?: string | undefined;
}

export class CreateFavoriteListResponse implements ICreateFavoriteListResponse {
    id?: number;

    constructor(data?: ICreateFavoriteListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateFavoriteListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFavoriteListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateFavoriteListResponse {
    id?: number;
}

export class UpdateFavoriteListCommand implements IUpdateFavoriteListCommand {
    id?: number;
    name?: string | undefined;

    constructor(data?: IUpdateFavoriteListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateFavoriteListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFavoriteListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateFavoriteListCommand {
    id?: number;
    name?: string | undefined;
}

export class DeleteFavoriteListCommand implements IDeleteFavoriteListCommand {
    id?: number;

    constructor(data?: IDeleteFavoriteListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteFavoriteListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFavoriteListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteFavoriteListCommand {
    id?: number;
}

export class CacheInvalidateFavoriteListCommand implements ICacheInvalidateFavoriteListCommand {

    constructor(data?: ICacheInvalidateFavoriteListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CacheInvalidateFavoriteListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CacheInvalidateFavoriteListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICacheInvalidateFavoriteListCommand {
}

export class AddItemToFavoriteListCommand implements IAddItemToFavoriteListCommand {
    favoriteListId?: number;
    productKey?: string | undefined;

    constructor(data?: IAddItemToFavoriteListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.favoriteListId = _data["favoriteListId"];
            this.productKey = _data["productKey"];
        }
    }

    static fromJS(data: any): AddItemToFavoriteListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddItemToFavoriteListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["favoriteListId"] = this.favoriteListId;
        data["productKey"] = this.productKey;
        return data;
    }
}

export interface IAddItemToFavoriteListCommand {
    favoriteListId?: number;
    productKey?: string | undefined;
}

export class FavoriteListItemKey implements IFavoriteListItemKey {
    productKey?: string | undefined;
    favoriteListId?: number;

    constructor(data?: IFavoriteListItemKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productKey = _data["productKey"];
            this.favoriteListId = _data["favoriteListId"];
        }
    }

    static fromJS(data: any): FavoriteListItemKey {
        data = typeof data === 'object' ? data : {};
        let result = new FavoriteListItemKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productKey"] = this.productKey;
        data["favoriteListId"] = this.favoriteListId;
        return data;
    }
}

export interface IFavoriteListItemKey {
    productKey?: string | undefined;
    favoriteListId?: number;
}

export class AddItemToFavoriteListResponse implements IAddItemToFavoriteListResponse {
    itemKey?: FavoriteListItemKey | undefined;

    constructor(data?: IAddItemToFavoriteListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemKey = _data["itemKey"] ? FavoriteListItemKey.fromJS(_data["itemKey"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddItemToFavoriteListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddItemToFavoriteListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemKey"] = this.itemKey ? this.itemKey.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddItemToFavoriteListResponse {
    itemKey?: FavoriteListItemKey | undefined;
}

export class RemoveItemFromFavoriteListCommand implements IRemoveItemFromFavoriteListCommand {
    productKey?: string | undefined;
    favoriteListId?: number;

    constructor(data?: IRemoveItemFromFavoriteListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productKey = _data["productKey"];
            this.favoriteListId = _data["favoriteListId"];
        }
    }

    static fromJS(data: any): RemoveItemFromFavoriteListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveItemFromFavoriteListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productKey"] = this.productKey;
        data["favoriteListId"] = this.favoriteListId;
        return data;
    }
}

export interface IRemoveItemFromFavoriteListCommand {
    productKey?: string | undefined;
    favoriteListId?: number;
}

export class RemoveItemFromAllFavoriteListsCommand implements IRemoveItemFromAllFavoriteListsCommand {
    productKey?: string | undefined;

    constructor(data?: IRemoveItemFromAllFavoriteListsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productKey = _data["productKey"];
        }
    }

    static fromJS(data: any): RemoveItemFromAllFavoriteListsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveItemFromAllFavoriteListsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productKey"] = this.productKey;
        return data;
    }
}

export interface IRemoveItemFromAllFavoriteListsCommand {
    productKey?: string | undefined;
}

export class PostZip implements IPostZip {
    wordDocType?: string | undefined;
    wordDoc?: string | undefined;
    image?: string | undefined;

    constructor(data?: IPostZip) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wordDocType = _data["wordDocType"];
            this.wordDoc = _data["wordDoc"];
            this.image = _data["image"];
        }
    }

    static fromJS(data: any): PostZip {
        data = typeof data === 'object' ? data : {};
        let result = new PostZip();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wordDocType"] = this.wordDocType;
        data["wordDoc"] = this.wordDoc;
        data["image"] = this.image;
        return data;
    }
}

export interface IPostZip {
    wordDocType?: string | undefined;
    wordDoc?: string | undefined;
    image?: string | undefined;
}

export class StringStringIEnumerableKeyValuePair implements IStringStringIEnumerableKeyValuePair {
    key?: string | undefined;
    value?: string[] | undefined;

    constructor(data?: IStringStringIEnumerableKeyValuePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static fromJS(data: any): StringStringIEnumerableKeyValuePair {
        data = typeof data === 'object' ? data : {};
        let result = new StringStringIEnumerableKeyValuePair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data;
    }
}

export interface IStringStringIEnumerableKeyValuePair {
    key?: string | undefined;
    value?: string[] | undefined;
}

export class HttpContent implements IHttpContent {
    readonly headers?: StringStringIEnumerableKeyValuePair[] | undefined;

    constructor(data?: IHttpContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(StringStringIEnumerableKeyValuePair.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HttpContent {
        data = typeof data === 'object' ? data : {};
        let result = new HttpContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHttpContent {
    headers?: StringStringIEnumerableKeyValuePair[] | undefined;
}

export enum HttpStatusCode {
    _100 = 100,
    _101 = 101,
    _102 = 102,
    _103 = 103,
    _200 = 200,
    _201 = 201,
    _202 = 202,
    _203 = 203,
    _204 = 204,
    _205 = 205,
    _206 = 206,
    _207 = 207,
    _208 = 208,
    _226 = 226,
    _300 = 300,
    _301 = 301,
    _302 = 302,
    _303 = 303,
    _304 = 304,
    _305 = 305,
    _306 = 306,
    _307 = 307,
    _308 = 308,
    _400 = 400,
    _401 = 401,
    _402 = 402,
    _403 = 403,
    _404 = 404,
    _405 = 405,
    _406 = 406,
    _407 = 407,
    _408 = 408,
    _409 = 409,
    _410 = 410,
    _411 = 411,
    _412 = 412,
    _413 = 413,
    _414 = 414,
    _415 = 415,
    _416 = 416,
    _417 = 417,
    _421 = 421,
    _422 = 422,
    _423 = 423,
    _424 = 424,
    _426 = 426,
    _428 = 428,
    _429 = 429,
    _431 = 431,
    _451 = 451,
    _500 = 500,
    _501 = 501,
    _502 = 502,
    _503 = 503,
    _504 = 504,
    _505 = 505,
    _506 = 506,
    _507 = 507,
    _508 = 508,
    _510 = 510,
    _511 = 511,
}

export class HttpMethod implements IHttpMethod {
    method?: string | undefined;

    constructor(data?: IHttpMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.method = _data["method"];
        }
    }

    static fromJS(data: any): HttpMethod {
        data = typeof data === 'object' ? data : {};
        let result = new HttpMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method;
        return data;
    }
}

export interface IHttpMethod {
    method?: string | undefined;
}

export class HttpRequestMessage implements IHttpRequestMessage {
    version?: string | undefined;
    content?: HttpContent | undefined;
    method?: HttpMethod | undefined;
    requestUri?: string | undefined;
    readonly headers?: StringStringIEnumerableKeyValuePair[] | undefined;
    readonly properties?: { [key: string]: any; } | undefined;

    constructor(data?: IHttpRequestMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.content = _data["content"] ? HttpContent.fromJS(_data["content"]) : <any>undefined;
            this.method = _data["method"] ? HttpMethod.fromJS(_data["method"]) : <any>undefined;
            this.requestUri = _data["requestUri"];
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(StringStringIEnumerableKeyValuePair.fromJS(item));
            }
            if (_data["properties"]) {
                (<any>this).properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>(<any>this).properties)![key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): HttpRequestMessage {
        data = typeof data === 'object' ? data : {};
        let result = new HttpRequestMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["method"] = this.method ? this.method.toJSON() : <any>undefined;
        data["requestUri"] = this.requestUri;
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key];
            }
        }
        return data;
    }
}

export interface IHttpRequestMessage {
    version?: string | undefined;
    content?: HttpContent | undefined;
    method?: HttpMethod | undefined;
    requestUri?: string | undefined;
    headers?: StringStringIEnumerableKeyValuePair[] | undefined;
    properties?: { [key: string]: any; } | undefined;
}

export class HttpResponseMessage implements IHttpResponseMessage {
    version?: string | undefined;
    content?: HttpContent | undefined;
    statusCode?: HttpStatusCode;
    reasonPhrase?: string | undefined;
    readonly headers?: StringStringIEnumerableKeyValuePair[] | undefined;
    readonly trailingHeaders?: StringStringIEnumerableKeyValuePair[] | undefined;
    requestMessage?: HttpRequestMessage | undefined;
    readonly isSuccessStatusCode?: boolean;

    constructor(data?: IHttpResponseMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.content = _data["content"] ? HttpContent.fromJS(_data["content"]) : <any>undefined;
            this.statusCode = _data["statusCode"];
            this.reasonPhrase = _data["reasonPhrase"];
            if (Array.isArray(_data["headers"])) {
                (<any>this).headers = [] as any;
                for (let item of _data["headers"])
                    (<any>this).headers!.push(StringStringIEnumerableKeyValuePair.fromJS(item));
            }
            if (Array.isArray(_data["trailingHeaders"])) {
                (<any>this).trailingHeaders = [] as any;
                for (let item of _data["trailingHeaders"])
                    (<any>this).trailingHeaders!.push(StringStringIEnumerableKeyValuePair.fromJS(item));
            }
            this.requestMessage = _data["requestMessage"] ? HttpRequestMessage.fromJS(_data["requestMessage"]) : <any>undefined;
            (<any>this).isSuccessStatusCode = _data["isSuccessStatusCode"];
        }
    }

    static fromJS(data: any): HttpResponseMessage {
        data = typeof data === 'object' ? data : {};
        let result = new HttpResponseMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        data["reasonPhrase"] = this.reasonPhrase;
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        if (Array.isArray(this.trailingHeaders)) {
            data["trailingHeaders"] = [];
            for (let item of this.trailingHeaders)
                data["trailingHeaders"].push(item.toJSON());
        }
        data["requestMessage"] = this.requestMessage ? this.requestMessage.toJSON() : <any>undefined;
        data["isSuccessStatusCode"] = this.isSuccessStatusCode;
        return data;
    }
}

export interface IHttpResponseMessage {
    version?: string | undefined;
    content?: HttpContent | undefined;
    statusCode?: HttpStatusCode;
    reasonPhrase?: string | undefined;
    headers?: StringStringIEnumerableKeyValuePair[] | undefined;
    trailingHeaders?: StringStringIEnumerableKeyValuePair[] | undefined;
    requestMessage?: HttpRequestMessage | undefined;
    isSuccessStatusCode?: boolean;
}

export class GetJobsQuery implements IGetJobsQuery {

    constructor(data?: IGetJobsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetJobsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetJobsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetJobsQuery {
}

export class IJobDescription implements IIJobDescription {
    readonly id?: string;
    readonly name?: string | undefined;
    readonly configuration?: any | undefined;
    readonly type?: string | undefined;

    constructor(data?: IIJobDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).name = _data["name"];
            (<any>this).configuration = _data["configuration"];
            (<any>this).type = _data["type"];
        }
    }

    static fromJS(data: any): IJobDescription {
        data = typeof data === 'object' ? data : {};
        let result = new IJobDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["configuration"] = this.configuration;
        data["type"] = this.type;
        return data;
    }
}

export interface IIJobDescription {
    id?: string;
    name?: string | undefined;
    configuration?: any | undefined;
    type?: string | undefined;
}

export enum DebugCommandResponseType {
    _0 = 0,
}

export class IDebugCommand implements IIDebugCommand {
    readonly name?: string | undefined;
    readonly description?: string | undefined;
    readonly responseType?: DebugCommandResponseType;

    constructor(data?: IIDebugCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            (<any>this).description = _data["description"];
            (<any>this).responseType = _data["responseType"];
        }
    }

    static fromJS(data: any): IDebugCommand {
        data = typeof data === 'object' ? data : {};
        let result = new IDebugCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["responseType"] = this.responseType;
        return data;
    }
}

export interface IIDebugCommand {
    name?: string | undefined;
    description?: string | undefined;
    responseType?: DebugCommandResponseType;
}

export class IJobTaskDescription implements IIJobTaskDescription {
    readonly job?: IJobDescription | undefined;
    readonly debugCommands?: IDebugCommand[] | undefined;

    constructor(data?: IIJobTaskDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).job = _data["job"] ? IJobDescription.fromJS(_data["job"]) : <any>undefined;
            if (Array.isArray(_data["debugCommands"])) {
                (<any>this).debugCommands = [] as any;
                for (let item of _data["debugCommands"])
                    (<any>this).debugCommands!.push(IDebugCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IJobTaskDescription {
        data = typeof data === 'object' ? data : {};
        let result = new IJobTaskDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["job"] = this.job ? this.job.toJSON() : <any>undefined;
        if (Array.isArray(this.debugCommands)) {
            data["debugCommands"] = [];
            for (let item of this.debugCommands)
                data["debugCommands"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIJobTaskDescription {
    job?: IJobDescription | undefined;
    debugCommands?: IDebugCommand[] | undefined;
}

export class GetJobsResponse implements IGetJobsResponse {
    jobs?: IJobTaskDescription[] | undefined;

    constructor(data?: IGetJobsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["jobs"])) {
                this.jobs = [] as any;
                for (let item of _data["jobs"])
                    this.jobs!.push(IJobTaskDescription.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJobsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetJobsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.jobs)) {
            data["jobs"] = [];
            for (let item of this.jobs)
                data["jobs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJobsResponse {
    jobs?: IJobTaskDescription[] | undefined;
}

export enum Importance {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum RunningJobState {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class IRunningJob implements IIRunningJob {
    readonly id?: string;
    readonly created?: Date;
    started?: Date | undefined;
    readonly jobDescription?: IJobTaskDescription | undefined;
    state?: RunningJobState;
    importance?: Importance;
    exception?: any | undefined;

    constructor(data?: IIRunningJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.started = _data["started"] ? new Date(_data["started"].toString()) : <any>undefined;
            (<any>this).jobDescription = _data["jobDescription"] ? IJobTaskDescription.fromJS(_data["jobDescription"]) : <any>undefined;
            this.state = _data["state"];
            this.importance = _data["importance"];
            this.exception = _data["exception"];
        }
    }

    static fromJS(data: any): IRunningJob {
        data = typeof data === 'object' ? data : {};
        let result = new IRunningJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["started"] = this.started ? this.started.toISOString() : <any>undefined;
        data["jobDescription"] = this.jobDescription ? this.jobDescription.toJSON() : <any>undefined;
        data["state"] = this.state;
        data["importance"] = this.importance;
        data["exception"] = this.exception;
        return data;
    }
}

export interface IIRunningJob {
    id?: string;
    created?: Date;
    started?: Date | undefined;
    jobDescription?: IJobTaskDescription | undefined;
    state?: RunningJobState;
    importance?: Importance;
    exception?: any | undefined;
}

export class JobGroupBy implements IJobGroupBy {
    jobName?: string | undefined;
    runningJobs?: IRunningJob[] | undefined;

    constructor(data?: IJobGroupBy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobName = _data["jobName"];
            if (Array.isArray(_data["runningJobs"])) {
                this.runningJobs = [] as any;
                for (let item of _data["runningJobs"])
                    this.runningJobs!.push(IRunningJob.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JobGroupBy {
        data = typeof data === 'object' ? data : {};
        let result = new JobGroupBy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobName"] = this.jobName;
        if (Array.isArray(this.runningJobs)) {
            data["runningJobs"] = [];
            for (let item of this.runningJobs)
                data["runningJobs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IJobGroupBy {
    jobName?: string | undefined;
    runningJobs?: IRunningJob[] | undefined;
}

export class GetRunningJobsResponse implements IGetRunningJobsResponse {
    jobs?: IRunningJob[] | undefined;
    readonly groupedBy?: JobGroupBy[] | undefined;

    constructor(data?: IGetRunningJobsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["jobs"])) {
                this.jobs = [] as any;
                for (let item of _data["jobs"])
                    this.jobs!.push(IRunningJob.fromJS(item));
            }
            if (Array.isArray(_data["groupedBy"])) {
                (<any>this).groupedBy = [] as any;
                for (let item of _data["groupedBy"])
                    (<any>this).groupedBy!.push(JobGroupBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRunningJobsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRunningJobsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.jobs)) {
            data["jobs"] = [];
            for (let item of this.jobs)
                data["jobs"].push(item.toJSON());
        }
        if (Array.isArray(this.groupedBy)) {
            data["groupedBy"] = [];
            for (let item of this.groupedBy)
                data["groupedBy"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRunningJobsResponse {
    jobs?: IRunningJob[] | undefined;
    groupedBy?: JobGroupBy[] | undefined;
}

export class GetJobTypesQuery implements IGetJobTypesQuery {

    constructor(data?: IGetJobTypesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetJobTypesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetJobTypesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetJobTypesQuery {
}

export enum JobTypeFieldType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export class JobTypeField implements IJobTypeField {
    name?: string | undefined;
    description?: string | undefined;
    fieldType?: JobTypeFieldType;

    constructor(data?: IJobTypeField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.fieldType = _data["fieldType"];
        }
    }

    static fromJS(data: any): JobTypeField {
        data = typeof data === 'object' ? data : {};
        let result = new JobTypeField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["fieldType"] = this.fieldType;
        return data;
    }
}

export interface IJobTypeField {
    name?: string | undefined;
    description?: string | undefined;
    fieldType?: JobTypeFieldType;
}

export class JobType implements IJobType {
    declarationType?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    fields?: JobTypeField[] | undefined;

    constructor(data?: IJobType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.declarationType = _data["declarationType"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(JobTypeField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JobType {
        data = typeof data === 'object' ? data : {};
        let result = new JobType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["declarationType"] = this.declarationType;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IJobType {
    declarationType?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    fields?: JobTypeField[] | undefined;
}

export class GetJobTypesResponse implements IGetJobTypesResponse {
    jobTypes?: JobType[] | undefined;

    constructor(data?: IGetJobTypesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["jobTypes"])) {
                this.jobTypes = [] as any;
                for (let item of _data["jobTypes"])
                    this.jobTypes!.push(JobType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJobTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetJobTypesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.jobTypes)) {
            data["jobTypes"] = [];
            for (let item of this.jobTypes)
                data["jobTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJobTypesResponse {
    jobTypes?: JobType[] | undefined;
}

export class StartJobCommand implements IStartJobCommand {
    jobId?: string;

    constructor(data?: IStartJobCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
        }
    }

    static fromJS(data: any): StartJobCommand {
        data = typeof data === 'object' ? data : {};
        let result = new StartJobCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        return data;
    }
}

export interface IStartJobCommand {
    jobId?: string;
}

export class OrderingListUserPermissionViewModel implements IOrderingListUserPermissionViewModel {
    userIdentity?: string | undefined;
    orderingListId?: string;
    canAdditemFromParent?: boolean;
    canRequestAddOfItem?: boolean;
    canExceedBudget?: boolean;
    canViewBudget?: boolean;
    canViewOrderHistoric?: boolean;
    canSeeDeletedFromParent?: boolean;

    constructor(data?: IOrderingListUserPermissionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userIdentity = _data["userIdentity"];
            this.orderingListId = _data["orderingListId"];
            this.canAdditemFromParent = _data["canAdditemFromParent"];
            this.canRequestAddOfItem = _data["canRequestAddOfItem"];
            this.canExceedBudget = _data["canExceedBudget"];
            this.canViewBudget = _data["canViewBudget"];
            this.canViewOrderHistoric = _data["canViewOrderHistoric"];
            this.canSeeDeletedFromParent = _data["canSeeDeletedFromParent"];
        }
    }

    static fromJS(data: any): OrderingListUserPermissionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderingListUserPermissionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userIdentity"] = this.userIdentity;
        data["orderingListId"] = this.orderingListId;
        data["canAdditemFromParent"] = this.canAdditemFromParent;
        data["canRequestAddOfItem"] = this.canRequestAddOfItem;
        data["canExceedBudget"] = this.canExceedBudget;
        data["canViewBudget"] = this.canViewBudget;
        data["canViewOrderHistoric"] = this.canViewOrderHistoric;
        data["canSeeDeletedFromParent"] = this.canSeeDeletedFromParent;
        return data;
    }
}

export interface IOrderingListUserPermissionViewModel {
    userIdentity?: string | undefined;
    orderingListId?: string;
    canAdditemFromParent?: boolean;
    canRequestAddOfItem?: boolean;
    canExceedBudget?: boolean;
    canViewBudget?: boolean;
    canViewOrderHistoric?: boolean;
    canSeeDeletedFromParent?: boolean;
}

export enum OrderingListState {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class OrderingListItemViewModel implements IOrderingListItemViewModel {
    parentId?: string;
    productKey?: string | undefined;
    sortOrder?: number;
    note?: string | undefined;
    state?: OrderingListState;
    isActive?: boolean;
    isAvailable?: boolean;
    isDeleted?: boolean;
    canDelete?: boolean;
    isCustomerAgreement?: boolean;

    constructor(data?: IOrderingListItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.productKey = _data["productKey"];
            this.sortOrder = _data["sortOrder"];
            this.note = _data["note"];
            this.state = _data["state"];
            this.isActive = _data["isActive"];
            this.isAvailable = _data["isAvailable"];
            this.isDeleted = _data["isDeleted"];
            this.canDelete = _data["canDelete"];
            this.isCustomerAgreement = _data["isCustomerAgreement"];
        }
    }

    static fromJS(data: any): OrderingListItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderingListItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["productKey"] = this.productKey;
        data["sortOrder"] = this.sortOrder;
        data["note"] = this.note;
        data["state"] = this.state;
        data["isActive"] = this.isActive;
        data["isAvailable"] = this.isAvailable;
        data["isDeleted"] = this.isDeleted;
        data["canDelete"] = this.canDelete;
        data["isCustomerAgreement"] = this.isCustomerAgreement;
        return data;
    }
}

export interface IOrderingListItemViewModel {
    parentId?: string;
    productKey?: string | undefined;
    sortOrder?: number;
    note?: string | undefined;
    state?: OrderingListState;
    isActive?: boolean;
    isAvailable?: boolean;
    isDeleted?: boolean;
    canDelete?: boolean;
    isCustomerAgreement?: boolean;
}

export class UserHierarchyViewModel implements IUserHierarchyViewModel {
    userIdentity?: string | undefined;
    customerNumber?: string | undefined;
    parentCustomerNumber?: string | undefined;
    rootCustomerNumber?: string | undefined;
    level?: number;
    customerType?: string | undefined;
    customerAddress?: string | undefined;
    customerAddress2?: string | undefined;
    companyName?: string | undefined;
    email?: string | undefined;
    postalCode?: string | undefined;
    countryCode?: string | undefined;
    postalCity?: string | undefined;
    parent?: UserHierarchyViewModel | undefined;

    constructor(data?: IUserHierarchyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userIdentity = _data["userIdentity"];
            this.customerNumber = _data["customerNumber"];
            this.parentCustomerNumber = _data["parentCustomerNumber"];
            this.rootCustomerNumber = _data["rootCustomerNumber"];
            this.level = _data["level"];
            this.customerType = _data["customerType"];
            this.customerAddress = _data["customerAddress"];
            this.customerAddress2 = _data["customerAddress2"];
            this.companyName = _data["companyName"];
            this.email = _data["email"];
            this.postalCode = _data["postalCode"];
            this.countryCode = _data["countryCode"];
            this.postalCity = _data["postalCity"];
            this.parent = _data["parent"] ? UserHierarchyViewModel.fromJS(_data["parent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserHierarchyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserHierarchyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userIdentity"] = this.userIdentity;
        data["customerNumber"] = this.customerNumber;
        data["parentCustomerNumber"] = this.parentCustomerNumber;
        data["rootCustomerNumber"] = this.rootCustomerNumber;
        data["level"] = this.level;
        data["customerType"] = this.customerType;
        data["customerAddress"] = this.customerAddress;
        data["customerAddress2"] = this.customerAddress2;
        data["companyName"] = this.companyName;
        data["email"] = this.email;
        data["postalCode"] = this.postalCode;
        data["countryCode"] = this.countryCode;
        data["postalCity"] = this.postalCity;
        data["parent"] = this.parent ? this.parent.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserHierarchyViewModel {
    userIdentity?: string | undefined;
    customerNumber?: string | undefined;
    parentCustomerNumber?: string | undefined;
    rootCustomerNumber?: string | undefined;
    level?: number;
    customerType?: string | undefined;
    customerAddress?: string | undefined;
    customerAddress2?: string | undefined;
    companyName?: string | undefined;
    email?: string | undefined;
    postalCode?: string | undefined;
    countryCode?: string | undefined;
    postalCity?: string | undefined;
    parent?: UserHierarchyViewModel | undefined;
}

export enum BudgetFrequency {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class UserPermission implements IUserPermission {
    readonly userType?: string | undefined;
    canAddItemFromParent?: boolean;
    canSeeDeletedFromParent?: boolean;
    canRequestAddOfItem?: boolean;
    canExceedBudget?: boolean;
    canViewBudget?: boolean;
    canViewOrderHistoric?: boolean;
    readonly created?: Date;
    readonly updated?: Date;
    rootUserIsolationKey?: string | undefined;
    budgetFrequency?: BudgetFrequency;
    unusedBudgetShouldBeTransferredToNextPeriod?: boolean;
    ignoreForwardBillingOrder?: boolean;
    userIdentity?: string | undefined;
    orderingListId?: string;

    constructor(data?: IUserPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).userType = _data["userType"];
            this.canAddItemFromParent = _data["canAddItemFromParent"];
            this.canSeeDeletedFromParent = _data["canSeeDeletedFromParent"];
            this.canRequestAddOfItem = _data["canRequestAddOfItem"];
            this.canExceedBudget = _data["canExceedBudget"];
            this.canViewBudget = _data["canViewBudget"];
            this.canViewOrderHistoric = _data["canViewOrderHistoric"];
            (<any>this).created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            (<any>this).updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.rootUserIsolationKey = _data["rootUserIsolationKey"];
            this.budgetFrequency = _data["budgetFrequency"];
            this.unusedBudgetShouldBeTransferredToNextPeriod = _data["unusedBudgetShouldBeTransferredToNextPeriod"];
            this.ignoreForwardBillingOrder = _data["ignoreForwardBillingOrder"];
            this.userIdentity = _data["userIdentity"];
            this.orderingListId = _data["orderingListId"];
        }
    }

    static fromJS(data: any): UserPermission {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userType"] = this.userType;
        data["canAddItemFromParent"] = this.canAddItemFromParent;
        data["canSeeDeletedFromParent"] = this.canSeeDeletedFromParent;
        data["canRequestAddOfItem"] = this.canRequestAddOfItem;
        data["canExceedBudget"] = this.canExceedBudget;
        data["canViewBudget"] = this.canViewBudget;
        data["canViewOrderHistoric"] = this.canViewOrderHistoric;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["rootUserIsolationKey"] = this.rootUserIsolationKey;
        data["budgetFrequency"] = this.budgetFrequency;
        data["unusedBudgetShouldBeTransferredToNextPeriod"] = this.unusedBudgetShouldBeTransferredToNextPeriod;
        data["ignoreForwardBillingOrder"] = this.ignoreForwardBillingOrder;
        data["userIdentity"] = this.userIdentity;
        data["orderingListId"] = this.orderingListId;
        return data;
    }
}

export interface IUserPermission {
    userType?: string | undefined;
    canAddItemFromParent?: boolean;
    canSeeDeletedFromParent?: boolean;
    canRequestAddOfItem?: boolean;
    canExceedBudget?: boolean;
    canViewBudget?: boolean;
    canViewOrderHistoric?: boolean;
    created?: Date;
    updated?: Date;
    rootUserIsolationKey?: string | undefined;
    budgetFrequency?: BudgetFrequency;
    unusedBudgetShouldBeTransferredToNextPeriod?: boolean;
    ignoreForwardBillingOrder?: boolean;
    userIdentity?: string | undefined;
    orderingListId?: string;
}

export class OrderingListViewModel implements IOrderingListViewModel {
    id?: string;
    name?: string | undefined;
    deliveryAddress?: string | undefined;
    level?: number;
    userIsolationKey?: string | undefined;
    parentUserIsolationKey?: string | undefined;
    budgetPerMonth?: number | undefined;
    permissions?: OrderingListUserPermissionViewModel | undefined;
    unusedBudgetShouldBeTransferredToNextPeriod?: boolean;
    ignoreForwardBillingOrder?: boolean;
    items?: OrderingListItemViewModel[] | undefined;
    userHierarchy?: UserHierarchyViewModel | undefined;
    isCurrentUserList?: boolean;
    customerType?: string | undefined;
    hierarchyType?: string | undefined;
    listUserPermission?: UserPermission | undefined;

    constructor(data?: IOrderingListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.level = _data["level"];
            this.userIsolationKey = _data["userIsolationKey"];
            this.parentUserIsolationKey = _data["parentUserIsolationKey"];
            this.budgetPerMonth = _data["budgetPerMonth"];
            this.permissions = _data["permissions"] ? OrderingListUserPermissionViewModel.fromJS(_data["permissions"]) : <any>undefined;
            this.unusedBudgetShouldBeTransferredToNextPeriod = _data["unusedBudgetShouldBeTransferredToNextPeriod"];
            this.ignoreForwardBillingOrder = _data["ignoreForwardBillingOrder"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderingListItemViewModel.fromJS(item));
            }
            this.userHierarchy = _data["userHierarchy"] ? UserHierarchyViewModel.fromJS(_data["userHierarchy"]) : <any>undefined;
            this.isCurrentUserList = _data["isCurrentUserList"];
            this.customerType = _data["customerType"];
            this.hierarchyType = _data["hierarchyType"];
            this.listUserPermission = _data["listUserPermission"] ? UserPermission.fromJS(_data["listUserPermission"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderingListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderingListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["deliveryAddress"] = this.deliveryAddress;
        data["level"] = this.level;
        data["userIsolationKey"] = this.userIsolationKey;
        data["parentUserIsolationKey"] = this.parentUserIsolationKey;
        data["budgetPerMonth"] = this.budgetPerMonth;
        data["permissions"] = this.permissions ? this.permissions.toJSON() : <any>undefined;
        data["unusedBudgetShouldBeTransferredToNextPeriod"] = this.unusedBudgetShouldBeTransferredToNextPeriod;
        data["ignoreForwardBillingOrder"] = this.ignoreForwardBillingOrder;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["userHierarchy"] = this.userHierarchy ? this.userHierarchy.toJSON() : <any>undefined;
        data["isCurrentUserList"] = this.isCurrentUserList;
        data["customerType"] = this.customerType;
        data["hierarchyType"] = this.hierarchyType;
        data["listUserPermission"] = this.listUserPermission ? this.listUserPermission.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrderingListViewModel {
    id?: string;
    name?: string | undefined;
    deliveryAddress?: string | undefined;
    level?: number;
    userIsolationKey?: string | undefined;
    parentUserIsolationKey?: string | undefined;
    budgetPerMonth?: number | undefined;
    permissions?: OrderingListUserPermissionViewModel | undefined;
    unusedBudgetShouldBeTransferredToNextPeriod?: boolean;
    ignoreForwardBillingOrder?: boolean;
    items?: OrderingListItemViewModel[] | undefined;
    userHierarchy?: UserHierarchyViewModel | undefined;
    isCurrentUserList?: boolean;
    customerType?: string | undefined;
    hierarchyType?: string | undefined;
    listUserPermission?: UserPermission | undefined;
}

export class GetMasterOrderingListResponse implements IGetMasterOrderingListResponse {
    readonly masterList?: OrderingListViewModel | undefined;

    constructor(data?: IGetMasterOrderingListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).masterList = _data["masterList"] ? OrderingListViewModel.fromJS(_data["masterList"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMasterOrderingListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMasterOrderingListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["masterList"] = this.masterList ? this.masterList.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMasterOrderingListResponse {
    masterList?: OrderingListViewModel | undefined;
}

export class GetByIdOrderingListResponse implements IGetByIdOrderingListResponse {
    orderingList?: OrderingListViewModel | undefined;

    constructor(data?: IGetByIdOrderingListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderingList = _data["orderingList"] ? OrderingListViewModel.fromJS(_data["orderingList"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetByIdOrderingListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetByIdOrderingListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderingList"] = this.orderingList ? this.orderingList.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetByIdOrderingListResponse {
    orderingList?: OrderingListViewModel | undefined;
}

export class OrderingListBudgetViewModel implements IOrderingListBudgetViewModel {
    realized?: number;

    constructor(data?: IOrderingListBudgetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.realized = _data["realized"];
        }
    }

    static fromJS(data: any): OrderingListBudgetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderingListBudgetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["realized"] = this.realized;
        return data;
    }
}

export interface IOrderingListBudgetViewModel {
    realized?: number;
}

export class GetRealizedBudgetResponse implements IGetRealizedBudgetResponse {
    budget?: OrderingListBudgetViewModel | undefined;

    constructor(data?: IGetRealizedBudgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budget = _data["budget"] ? OrderingListBudgetViewModel.fromJS(_data["budget"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRealizedBudgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRealizedBudgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budget"] = this.budget ? this.budget.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRealizedBudgetResponse {
    budget?: OrderingListBudgetViewModel | undefined;
}

export class GetAllOrderingListDetailsResponse implements IGetAllOrderingListDetailsResponse {
    orderingLists?: OrderingListViewModel[] | undefined;

    constructor(data?: IGetAllOrderingListDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderingLists"])) {
                this.orderingLists = [] as any;
                for (let item of _data["orderingLists"])
                    this.orderingLists!.push(OrderingListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllOrderingListDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllOrderingListDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderingLists)) {
            data["orderingLists"] = [];
            for (let item of this.orderingLists)
                data["orderingLists"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllOrderingListDetailsResponse {
    orderingLists?: OrderingListViewModel[] | undefined;
}

export class CreateOrderingListCommand implements ICreateOrderingListCommand {
    name?: string | undefined;
    userIdentity?: string | undefined;
    customerNumber?: string | undefined;
    parentCustomerNumber?: string | undefined;
    rootUserIsolationKey?: string | undefined;

    constructor(data?: ICreateOrderingListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.userIdentity = _data["userIdentity"];
            this.customerNumber = _data["customerNumber"];
            this.parentCustomerNumber = _data["parentCustomerNumber"];
            this.rootUserIsolationKey = _data["rootUserIsolationKey"];
        }
    }

    static fromJS(data: any): CreateOrderingListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderingListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["userIdentity"] = this.userIdentity;
        data["customerNumber"] = this.customerNumber;
        data["parentCustomerNumber"] = this.parentCustomerNumber;
        data["rootUserIsolationKey"] = this.rootUserIsolationKey;
        return data;
    }
}

export interface ICreateOrderingListCommand {
    name?: string | undefined;
    userIdentity?: string | undefined;
    customerNumber?: string | undefined;
    parentCustomerNumber?: string | undefined;
    rootUserIsolationKey?: string | undefined;
}

export class CreateOrderingListResponse implements ICreateOrderingListResponse {
    id?: number;

    constructor(data?: ICreateOrderingListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrderingListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderingListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrderingListResponse {
    id?: number;
}

export class UpdateOrderingListCommand implements IUpdateOrderingListCommand {
    id?: string;
    name?: string | undefined;
    budget?: number | undefined;
    period?: number | undefined;
    unusedBudgetShouldBeTransferredToNextPeriod?: boolean | undefined;
    ignoreForwardBillingOrder?: boolean | undefined;
    userIsolationKey?: string | undefined;

    constructor(data?: IUpdateOrderingListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.budget = _data["budget"];
            this.period = _data["period"];
            this.unusedBudgetShouldBeTransferredToNextPeriod = _data["unusedBudgetShouldBeTransferredToNextPeriod"];
            this.ignoreForwardBillingOrder = _data["ignoreForwardBillingOrder"];
            this.userIsolationKey = _data["userIsolationKey"];
        }
    }

    static fromJS(data: any): UpdateOrderingListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderingListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["budget"] = this.budget;
        data["period"] = this.period;
        data["unusedBudgetShouldBeTransferredToNextPeriod"] = this.unusedBudgetShouldBeTransferredToNextPeriod;
        data["ignoreForwardBillingOrder"] = this.ignoreForwardBillingOrder;
        data["userIsolationKey"] = this.userIsolationKey;
        return data;
    }
}

export interface IUpdateOrderingListCommand {
    id?: string;
    name?: string | undefined;
    budget?: number | undefined;
    period?: number | undefined;
    unusedBudgetShouldBeTransferredToNextPeriod?: boolean | undefined;
    ignoreForwardBillingOrder?: boolean | undefined;
    userIsolationKey?: string | undefined;
}

export class DeleteOrderingListCommand implements IDeleteOrderingListCommand {
    id?: string;

    constructor(data?: IDeleteOrderingListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteOrderingListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteOrderingListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteOrderingListCommand {
    id?: string;
}

export class CacheInvalidateOrderingListCommand implements ICacheInvalidateOrderingListCommand {
    all?: boolean;
    customerNumber?: string | undefined;
    rootUserIsolationKey?: string | undefined;

    constructor(data?: ICacheInvalidateOrderingListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.all = _data["all"];
            this.customerNumber = _data["customerNumber"];
            this.rootUserIsolationKey = _data["rootUserIsolationKey"];
        }
    }

    static fromJS(data: any): CacheInvalidateOrderingListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CacheInvalidateOrderingListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["all"] = this.all;
        data["customerNumber"] = this.customerNumber;
        data["rootUserIsolationKey"] = this.rootUserIsolationKey;
        return data;
    }
}

export interface ICacheInvalidateOrderingListCommand {
    all?: boolean;
    customerNumber?: string | undefined;
    rootUserIsolationKey?: string | undefined;
}

export class AddItemToOrderingListCommand implements IAddItemToOrderingListCommand {
    orderingListId?: string;
    productKey?: string | undefined;

    constructor(data?: IAddItemToOrderingListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderingListId = _data["orderingListId"];
            this.productKey = _data["productKey"];
        }
    }

    static fromJS(data: any): AddItemToOrderingListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddItemToOrderingListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderingListId"] = this.orderingListId;
        data["productKey"] = this.productKey;
        return data;
    }
}

export interface IAddItemToOrderingListCommand {
    orderingListId?: string;
    productKey?: string | undefined;
}

export class RemoveItemFromOrderingListCommand implements IRemoveItemFromOrderingListCommand {
    orderingListId?: string;
    productKey?: string | undefined;

    constructor(data?: IRemoveItemFromOrderingListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderingListId = _data["orderingListId"];
            this.productKey = _data["productKey"];
        }
    }

    static fromJS(data: any): RemoveItemFromOrderingListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveItemFromOrderingListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderingListId"] = this.orderingListId;
        data["productKey"] = this.productKey;
        return data;
    }
}

export interface IRemoveItemFromOrderingListCommand {
    orderingListId?: string;
    productKey?: string | undefined;
}

export class AddItemToOrderingListResponse implements IAddItemToOrderingListResponse {
    id?: string;

    constructor(data?: IAddItemToOrderingListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AddItemToOrderingListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddItemToOrderingListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IAddItemToOrderingListResponse {
    id?: string;
}

export class UpdateIsActiveOnOrderingListItemCommand implements IUpdateIsActiveOnOrderingListItemCommand {
    orderingListId?: string;
    productKey?: string | undefined;
    isActive?: boolean;

    constructor(data?: IUpdateIsActiveOnOrderingListItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderingListId = _data["orderingListId"];
            this.productKey = _data["productKey"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateIsActiveOnOrderingListItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIsActiveOnOrderingListItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderingListId"] = this.orderingListId;
        data["productKey"] = this.productKey;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateIsActiveOnOrderingListItemCommand {
    orderingListId?: string;
    productKey?: string | undefined;
    isActive?: boolean;
}

export class UpdateIsDeletedOnOrderingListItemCommand implements IUpdateIsDeletedOnOrderingListItemCommand {
    orderingListId?: string;
    productKey?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: IUpdateIsDeletedOnOrderingListItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderingListId = _data["orderingListId"];
            this.productKey = _data["productKey"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): UpdateIsDeletedOnOrderingListItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIsDeletedOnOrderingListItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderingListId"] = this.orderingListId;
        data["productKey"] = this.productKey;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IUpdateIsDeletedOnOrderingListItemCommand {
    orderingListId?: string;
    productKey?: string | undefined;
    isDeleted?: boolean;
}

export class UpdateIsAvailableOnOrderingListItemCommand implements IUpdateIsAvailableOnOrderingListItemCommand {
    orderingListId?: string;
    productKey?: string | undefined;
    isAvailable?: boolean;

    constructor(data?: IUpdateIsAvailableOnOrderingListItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderingListId = _data["orderingListId"];
            this.productKey = _data["productKey"];
            this.isAvailable = _data["isAvailable"];
        }
    }

    static fromJS(data: any): UpdateIsAvailableOnOrderingListItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIsAvailableOnOrderingListItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderingListId"] = this.orderingListId;
        data["productKey"] = this.productKey;
        data["isAvailable"] = this.isAvailable;
        return data;
    }
}

export interface IUpdateIsAvailableOnOrderingListItemCommand {
    orderingListId?: string;
    productKey?: string | undefined;
    isAvailable?: boolean;
}

export class OrderingListPendingProductRequestViewModel implements IOrderingListPendingProductRequestViewModel {
    requestedByUserIdentity?: string | undefined;
    productKey?: string | undefined;
    created?: string | undefined;
    comments?: string | undefined;
    userName?: string | undefined;
    userEmail?: string | undefined;

    constructor(data?: IOrderingListPendingProductRequestViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestedByUserIdentity = _data["requestedByUserIdentity"];
            this.productKey = _data["productKey"];
            this.created = _data["created"];
            this.comments = _data["comments"];
            this.userName = _data["userName"];
            this.userEmail = _data["userEmail"];
        }
    }

    static fromJS(data: any): OrderingListPendingProductRequestViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderingListPendingProductRequestViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedByUserIdentity"] = this.requestedByUserIdentity;
        data["productKey"] = this.productKey;
        data["created"] = this.created;
        data["comments"] = this.comments;
        data["userName"] = this.userName;
        data["userEmail"] = this.userEmail;
        return data;
    }
}

export interface IOrderingListPendingProductRequestViewModel {
    requestedByUserIdentity?: string | undefined;
    productKey?: string | undefined;
    created?: string | undefined;
    comments?: string | undefined;
    userName?: string | undefined;
    userEmail?: string | undefined;
}

export class GetAllOrderingListPendingResponse implements IGetAllOrderingListPendingResponse {
    list?: OrderingListPendingProductRequestViewModel[] | undefined;

    constructor(data?: IGetAllOrderingListPendingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"])
                    this.list!.push(OrderingListPendingProductRequestViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllOrderingListPendingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllOrderingListPendingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllOrderingListPendingResponse {
    list?: OrderingListPendingProductRequestViewModel[] | undefined;
}

export class ApproveOrderingListRequestProductCommand implements IApproveOrderingListRequestProductCommand {
    productKey?: string | undefined;
    isAvailable?: boolean;

    constructor(data?: IApproveOrderingListRequestProductCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productKey = _data["productKey"];
            this.isAvailable = _data["isAvailable"];
        }
    }

    static fromJS(data: any): ApproveOrderingListRequestProductCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveOrderingListRequestProductCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productKey"] = this.productKey;
        data["isAvailable"] = this.isAvailable;
        return data;
    }
}

export interface IApproveOrderingListRequestProductCommand {
    productKey?: string | undefined;
    isAvailable?: boolean;
}

export class CancelOrderingListRequestProductCommand implements ICancelOrderingListRequestProductCommand {
    productKey?: string | undefined;

    constructor(data?: ICancelOrderingListRequestProductCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productKey = _data["productKey"];
        }
    }

    static fromJS(data: any): CancelOrderingListRequestProductCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CancelOrderingListRequestProductCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productKey"] = this.productKey;
        return data;
    }
}

export interface ICancelOrderingListRequestProductCommand {
    productKey?: string | undefined;
}

export class AddOrderingListRequestProductCommand implements IAddOrderingListRequestProductCommand {
    orderingListId?: string;
    productKey?: string | undefined;
    comments?: string | undefined;

    constructor(data?: IAddOrderingListRequestProductCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderingListId = _data["orderingListId"];
            this.productKey = _data["productKey"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): AddOrderingListRequestProductCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrderingListRequestProductCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderingListId"] = this.orderingListId;
        data["productKey"] = this.productKey;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IAddOrderingListRequestProductCommand {
    orderingListId?: string;
    productKey?: string | undefined;
    comments?: string | undefined;
}

export class GetAllEmailPendingRequest implements IGetAllEmailPendingRequest {

    constructor(data?: IGetAllEmailPendingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetAllEmailPendingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllEmailPendingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetAllEmailPendingRequest {
}

export class OrderingListPendingProductRequestEmailViewModel implements IOrderingListPendingProductRequestEmailViewModel {
    id?: string | undefined;
    productKey?: string | undefined;
    requestsByUser?: string | undefined;
    rootUser?: string | undefined;

    constructor(data?: IOrderingListPendingProductRequestEmailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.productKey = _data["productKey"];
            this.requestsByUser = _data["requestsByUser"];
            this.rootUser = _data["rootUser"];
        }
    }

    static fromJS(data: any): OrderingListPendingProductRequestEmailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderingListPendingProductRequestEmailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productKey"] = this.productKey;
        data["requestsByUser"] = this.requestsByUser;
        data["rootUser"] = this.rootUser;
        return data;
    }
}

export interface IOrderingListPendingProductRequestEmailViewModel {
    id?: string | undefined;
    productKey?: string | undefined;
    requestsByUser?: string | undefined;
    rootUser?: string | undefined;
}

export class GetAllEmailPendingResponse implements IGetAllEmailPendingResponse {
    list?: OrderingListPendingProductRequestEmailViewModel[] | undefined;

    constructor(data?: IGetAllEmailPendingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"])
                    this.list!.push(OrderingListPendingProductRequestEmailViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllEmailPendingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllEmailPendingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllEmailPendingResponse {
    list?: OrderingListPendingProductRequestEmailViewModel[] | undefined;
}

export class MarkOrderingPendingRequestAsSendRequest implements IMarkOrderingPendingRequestAsSendRequest {
    ids?: string[] | undefined;

    constructor(data?: IMarkOrderingPendingRequestAsSendRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): MarkOrderingPendingRequestAsSendRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkOrderingPendingRequestAsSendRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IMarkOrderingPendingRequestAsSendRequest {
    ids?: string[] | undefined;
}

export class GetAllOrderingListUserPermissionRequest implements IGetAllOrderingListUserPermissionRequest {

    constructor(data?: IGetAllOrderingListUserPermissionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetAllOrderingListUserPermissionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllOrderingListUserPermissionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetAllOrderingListUserPermissionRequest {
}

export class OrderingListDetailsWithPermissionViewModel implements IOrderingListDetailsWithPermissionViewModel {
    id?: string;
    name?: string | undefined;
    customerAddress?: string | undefined;
    permissions?: OrderingListUserPermissionViewModel | undefined;

    constructor(data?: IOrderingListDetailsWithPermissionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.customerAddress = _data["customerAddress"];
            this.permissions = _data["permissions"] ? OrderingListUserPermissionViewModel.fromJS(_data["permissions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderingListDetailsWithPermissionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderingListDetailsWithPermissionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["customerAddress"] = this.customerAddress;
        data["permissions"] = this.permissions ? this.permissions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrderingListDetailsWithPermissionViewModel {
    id?: string;
    name?: string | undefined;
    customerAddress?: string | undefined;
    permissions?: OrderingListUserPermissionViewModel | undefined;
}

export class OrderingListUserDetailViewModel implements IOrderingListUserDetailViewModel {
    userIdentity?: string | undefined;
    userName?: string | undefined;
    userEmail?: string | undefined;
    orderingLists?: OrderingListDetailsWithPermissionViewModel[] | undefined;

    constructor(data?: IOrderingListUserDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userIdentity = _data["userIdentity"];
            this.userName = _data["userName"];
            this.userEmail = _data["userEmail"];
            if (Array.isArray(_data["orderingLists"])) {
                this.orderingLists = [] as any;
                for (let item of _data["orderingLists"])
                    this.orderingLists!.push(OrderingListDetailsWithPermissionViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderingListUserDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrderingListUserDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userIdentity"] = this.userIdentity;
        data["userName"] = this.userName;
        data["userEmail"] = this.userEmail;
        if (Array.isArray(this.orderingLists)) {
            data["orderingLists"] = [];
            for (let item of this.orderingLists)
                data["orderingLists"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrderingListUserDetailViewModel {
    userIdentity?: string | undefined;
    userName?: string | undefined;
    userEmail?: string | undefined;
    orderingLists?: OrderingListDetailsWithPermissionViewModel[] | undefined;
}

export class GetAllOrderingListUserPermissionResponse implements IGetAllOrderingListUserPermissionResponse {
    readonly permissions?: OrderingListUserDetailViewModel[] | undefined;

    constructor(data?: IGetAllOrderingListUserPermissionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                (<any>this).permissions = [] as any;
                for (let item of _data["permissions"])
                    (<any>this).permissions!.push(OrderingListUserDetailViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllOrderingListUserPermissionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllOrderingListUserPermissionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllOrderingListUserPermissionResponse {
    permissions?: OrderingListUserDetailViewModel[] | undefined;
}

export class UpdateUserPermissionCommand implements IUpdateUserPermissionCommand {
    userIdentity?: string | undefined;
    orderingListId?: string;
    canAdditemFromParent?: boolean;
    canRequestAddOfItem?: boolean;
    canExceedBudget?: boolean;
    canViewBudget?: boolean;
    canViewOrderHistoric?: boolean;
    canSeeDeletedFromParent?: boolean;

    constructor(data?: IUpdateUserPermissionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userIdentity = _data["userIdentity"];
            this.orderingListId = _data["orderingListId"];
            this.canAdditemFromParent = _data["canAdditemFromParent"];
            this.canRequestAddOfItem = _data["canRequestAddOfItem"];
            this.canExceedBudget = _data["canExceedBudget"];
            this.canViewBudget = _data["canViewBudget"];
            this.canViewOrderHistoric = _data["canViewOrderHistoric"];
            this.canSeeDeletedFromParent = _data["canSeeDeletedFromParent"];
        }
    }

    static fromJS(data: any): UpdateUserPermissionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPermissionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userIdentity"] = this.userIdentity;
        data["orderingListId"] = this.orderingListId;
        data["canAdditemFromParent"] = this.canAdditemFromParent;
        data["canRequestAddOfItem"] = this.canRequestAddOfItem;
        data["canExceedBudget"] = this.canExceedBudget;
        data["canViewBudget"] = this.canViewBudget;
        data["canViewOrderHistoric"] = this.canViewOrderHistoric;
        data["canSeeDeletedFromParent"] = this.canSeeDeletedFromParent;
        return data;
    }
}

export interface IUpdateUserPermissionCommand {
    userIdentity?: string | undefined;
    orderingListId?: string;
    canAdditemFromParent?: boolean;
    canRequestAddOfItem?: boolean;
    canExceedBudget?: boolean;
    canViewBudget?: boolean;
    canViewOrderHistoric?: boolean;
    canSeeDeletedFromParent?: boolean;
}

export class CreateUserPermissionCommand implements ICreateUserPermissionCommand {
    orderingListId?: string;
    userIdentity?: string | undefined;

    constructor(data?: ICreateUserPermissionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderingListId = _data["orderingListId"];
            this.userIdentity = _data["userIdentity"];
        }
    }

    static fromJS(data: any): CreateUserPermissionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserPermissionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderingListId"] = this.orderingListId;
        data["userIdentity"] = this.userIdentity;
        return data;
    }
}

export interface ICreateUserPermissionCommand {
    orderingListId?: string;
    userIdentity?: string | undefined;
}

export class RemoveUserPermissionCommand implements IRemoveUserPermissionCommand {
    userIdentity?: string | undefined;
    orderingListId?: string;

    constructor(data?: IRemoveUserPermissionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userIdentity = _data["userIdentity"];
            this.orderingListId = _data["orderingListId"];
        }
    }

    static fromJS(data: any): RemoveUserPermissionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveUserPermissionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userIdentity"] = this.userIdentity;
        data["orderingListId"] = this.orderingListId;
        return data;
    }
}

export interface IRemoveUserPermissionCommand {
    userIdentity?: string | undefined;
    orderingListId?: string;
}

export class IReportingEvent implements IIReportingEvent {
    readonly timestamp?: Date;
    readonly eventType?: string | undefined;
    readonly data?: { [key: string]: any; } | undefined;

    constructor(data?: IIReportingEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            (<any>this).eventType = _data["eventType"];
            if (_data["data"]) {
                (<any>this).data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>(<any>this).data)![key] = _data["data"][key];
                }
            }
        }
    }

    static fromJS(data: any): IReportingEvent {
        data = typeof data === 'object' ? data : {};
        let result = new IReportingEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["eventType"] = this.eventType;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = this.data[key];
            }
        }
        return data;
    }
}

export interface IIReportingEvent {
    timestamp?: Date;
    eventType?: string | undefined;
    data?: { [key: string]: any; } | undefined;
}

export class GetReportingEventsResponse implements IGetReportingEventsResponse {
    events?: IReportingEvent[] | undefined;

    constructor(data?: IGetReportingEventsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(IReportingEvent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetReportingEventsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportingEventsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetReportingEventsResponse {
    events?: IReportingEvent[] | undefined;
}

export class GetJobSchedulesQuery implements IGetJobSchedulesQuery {

    constructor(data?: IGetJobSchedulesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetJobSchedulesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetJobSchedulesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetJobSchedulesQuery {
}

export enum DayOfWeek {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class JobSchedule implements IJobSchedule {
    jobId?: string;
    startsAt?: string;
    endsAt?: string | undefined;
    repeatsEvery?: string | undefined;
    runOnDays?: DayOfWeek[] | undefined;

    constructor(data?: IJobSchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.startsAt = _data["startsAt"];
            this.endsAt = _data["endsAt"];
            this.repeatsEvery = _data["repeatsEvery"];
            if (Array.isArray(_data["runOnDays"])) {
                this.runOnDays = [] as any;
                for (let item of _data["runOnDays"])
                    this.runOnDays!.push(item);
            }
        }
    }

    static fromJS(data: any): JobSchedule {
        data = typeof data === 'object' ? data : {};
        let result = new JobSchedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["startsAt"] = this.startsAt;
        data["endsAt"] = this.endsAt;
        data["repeatsEvery"] = this.repeatsEvery;
        if (Array.isArray(this.runOnDays)) {
            data["runOnDays"] = [];
            for (let item of this.runOnDays)
                data["runOnDays"].push(item);
        }
        return data;
    }
}

export interface IJobSchedule {
    jobId?: string;
    startsAt?: string;
    endsAt?: string | undefined;
    repeatsEvery?: string | undefined;
    runOnDays?: DayOfWeek[] | undefined;
}

export class GetJobSchedulesResponse implements IGetJobSchedulesResponse {
    jobSchedules?: JobSchedule[] | undefined;

    constructor(data?: IGetJobSchedulesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["jobSchedules"])) {
                this.jobSchedules = [] as any;
                for (let item of _data["jobSchedules"])
                    this.jobSchedules!.push(JobSchedule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJobSchedulesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetJobSchedulesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.jobSchedules)) {
            data["jobSchedules"] = [];
            for (let item of this.jobSchedules)
                data["jobSchedules"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetJobSchedulesResponse {
    jobSchedules?: JobSchedule[] | undefined;
}

export class GetJobScheduleByJobIdResponse implements IGetJobScheduleByJobIdResponse {
    jobSchedule?: JobSchedule | undefined;

    constructor(data?: IGetJobScheduleByJobIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobSchedule = _data["jobSchedule"] ? JobSchedule.fromJS(_data["jobSchedule"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetJobScheduleByJobIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetJobScheduleByJobIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobSchedule"] = this.jobSchedule ? this.jobSchedule.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetJobScheduleByJobIdResponse {
    jobSchedule?: JobSchedule | undefined;
}

export class DeleteJobScheduleByJobIdCommand implements IDeleteJobScheduleByJobIdCommand {
    jobId?: string;

    constructor(data?: IDeleteJobScheduleByJobIdCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
        }
    }

    static fromJS(data: any): DeleteJobScheduleByJobIdCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteJobScheduleByJobIdCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        return data;
    }
}

export interface IDeleteJobScheduleByJobIdCommand {
    jobId?: string;
}

export class AddOrUpdateJobScheduleCommand implements IAddOrUpdateJobScheduleCommand {
    jobSchedule?: JobSchedule | undefined;

    constructor(data?: IAddOrUpdateJobScheduleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobSchedule = _data["jobSchedule"] ? JobSchedule.fromJS(_data["jobSchedule"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddOrUpdateJobScheduleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrUpdateJobScheduleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobSchedule"] = this.jobSchedule ? this.jobSchedule.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddOrUpdateJobScheduleCommand {
    jobSchedule?: JobSchedule | undefined;
}

export class GetUserHierarchyDetailsRequest implements IGetUserHierarchyDetailsRequest {

    constructor(data?: IGetUserHierarchyDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetUserHierarchyDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserHierarchyDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetUserHierarchyDetailsRequest {
}

export class GetUserHierarchyDetailsResponse implements IGetUserHierarchyDetailsResponse {
    list?: { [key: string]: UserHierarchyViewModel[]; } | undefined;

    constructor(data?: IGetUserHierarchyDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["list"]) {
                this.list = {} as any;
                for (let key in _data["list"]) {
                    if (_data["list"].hasOwnProperty(key))
                        (<any>this.list)![key] = _data["list"][key] ? _data["list"][key].map((i: any) => UserHierarchyViewModel.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): GetUserHierarchyDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserHierarchyDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.list) {
            data["list"] = {};
            for (let key in this.list) {
                if (this.list.hasOwnProperty(key))
                    (<any>data["list"])[key] = this.list[key];
            }
        }
        return data;
    }
}

export interface IGetUserHierarchyDetailsResponse {
    list?: { [key: string]: UserHierarchyViewModel[]; } | undefined;
}

export class GetCreateNewChildUserHierarchyListRequest implements IGetCreateNewChildUserHierarchyListRequest {

    constructor(data?: IGetCreateNewChildUserHierarchyListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCreateNewChildUserHierarchyListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateNewChildUserHierarchyListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCreateNewChildUserHierarchyListRequest {
}

export class GetCreateNewChildUserHierarchyListResponse implements IGetCreateNewChildUserHierarchyListResponse {
    list?: { [key: string]: UserHierarchyViewModel[]; } | undefined;

    constructor(data?: IGetCreateNewChildUserHierarchyListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["list"]) {
                this.list = {} as any;
                for (let key in _data["list"]) {
                    if (_data["list"].hasOwnProperty(key))
                        (<any>this.list)![key] = _data["list"][key] ? _data["list"][key].map((i: any) => UserHierarchyViewModel.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): GetCreateNewChildUserHierarchyListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreateNewChildUserHierarchyListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.list) {
            data["list"] = {};
            for (let key in this.list) {
                if (this.list.hasOwnProperty(key))
                    (<any>data["list"])[key] = this.list[key];
            }
        }
        return data;
    }
}

export interface IGetCreateNewChildUserHierarchyListResponse {
    list?: { [key: string]: UserHierarchyViewModel[]; } | undefined;
}

export class GetUserHierarchyListWithoutOrderingListRequest implements IGetUserHierarchyListWithoutOrderingListRequest {

    constructor(data?: IGetUserHierarchyListWithoutOrderingListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetUserHierarchyListWithoutOrderingListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserHierarchyListWithoutOrderingListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetUserHierarchyListWithoutOrderingListRequest {
}

export class GetUserHierarchyListWithoutOrderingListResponse implements IGetUserHierarchyListWithoutOrderingListResponse {
    list?: { [key: string]: UserHierarchyViewModel[]; } | undefined;

    constructor(data?: IGetUserHierarchyListWithoutOrderingListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["list"]) {
                this.list = {} as any;
                for (let key in _data["list"]) {
                    if (_data["list"].hasOwnProperty(key))
                        (<any>this.list)![key] = _data["list"][key] ? _data["list"][key].map((i: any) => UserHierarchyViewModel.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): GetUserHierarchyListWithoutOrderingListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserHierarchyListWithoutOrderingListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.list) {
            data["list"] = {};
            for (let key in this.list) {
                if (this.list.hasOwnProperty(key))
                    (<any>data["list"])[key] = this.list[key];
            }
        }
        return data;
    }
}

export interface IGetUserHierarchyListWithoutOrderingListResponse {
    list?: { [key: string]: UserHierarchyViewModel[]; } | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}